import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as routingSelectors from '@makemydeal/dr-dash-store/selectors/router';
import { useRoleAssumptionSelector } from '@makemydeal/dr-shared-ui-utils';

import BackToMyDealButton from './BackButton.interstate';
import { BackButtonRow, HeaderRowContainer } from './Header.style.interstate';
import { CompactUIHeaderActions } from '../compactUIHeader/CompactUIHeaderActions';
import { HeaderRowInterstate } from './HeaderRow.interstate';
import { FixedHeaderContent } from './FixedHeaderContent.style';

export const ContentHeader = ({ assistantEntry }: { assistantEntry?: ReactNode }) => {
    const theme = useInterstateTheme();
    const dashboardIsCurrentRoute = useSelector(routingSelectors.isDashboardCurrentRoute);

    const showBackButton = !dashboardIsCurrentRoute;

    const { isRoleAssumptionStarted } = useRoleAssumptionSelector();

    return (
        <FixedHeaderContent theme={theme} isRoleAssumptionStarted={isRoleAssumptionStarted}>
            {showBackButton && (
                <BackButtonRow>
                    <BackToMyDealButton />
                </BackButtonRow>
            )}
            <HeaderRowContainer className="compact-ui-header" theme={theme}>
                <HeaderRowInterstate assistantEntry={assistantEntry} />
                <CompactUIHeaderActions />
            </HeaderRowContainer>
        </FixedHeaderContent>
    );
};

export default ContentHeader;
